module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ashou7-2b9aaea8a9637df68cfb9c3003ca90c1.jpg";